<p-breadcrumb
  [model]="[
    { label: 'Avaliações', routerLink: ['/assessments'] },
    {
      label: assessmentId() ? 'Editar Avaliação' : 'Nova Avaliação',
      routerLink: assessmentId()
        ? ['/assessments/update/' + assessmentId()]
        : ['/assessments/create']
    }
  ]"
  [home]="{ label: '', routerLink: ['/'], icon: 'ph-duotone ph-house text-lg' }"
/>

<form [formGroup]="formGroup" (ngSubmit)="onSubmit()" class="relative">
  <p-toolbar class="mb-5 mt-5">
    <div class="w-full flex flex-wrap justify-between items-center">
      <div>
        @if(assessmentId()){
        <h5 class="font-bold">Editar Avaliação</h5>
        <p>Confira e atualize informações</p>
        } @else {
        <h5 class="font-bold">Cadastrar Nova Avaliação</h5>
        <p>Preencha os campos abaixo para cadastrar</p>
        }
      </div>

      <div class="flex justify-end gap-5 items-center">
        @if(assessmentId()){
        <div class="w-full flex items-center gap-1">
          <label for="isActive"> Status: </label><br />
          <div class="flex gap-2 items-center">
            <p-toggleswitch formControlName="isActive" />
            {{ formGroup.get("isActive")!.value ? "Ativo" : "Inativo" }}
          </div>
        </div>
        }

        <div class="flex gap-2">
          <p-button
            label="Cancelar"
            routerLink="/assessments"
            severity="secondary"
            rounded
            class="btn-secondary-outline"
          >
          </p-button>
          <p-button type="submit" label="Salvar" rounded></p-button>
        </div>
      </div>
    </div>
  </p-toolbar>

  <div class="card space-y-5 w-full">
    <h5 class="font-bold">Informações gerais</h5>

    <div class="flex flex-wrap xl:flex-nowrap gap-5">
      <div class="w-full">
        <label for="name">Nome *</label>
        <input
          pInputText
          type="text"
          formControlName="name"
          class="w-full"
          placeholder="Informe o nome"
        />
        <app-form-error [control]="formGroup.get('name')" />
        <app-form-server-error [control]="formGroup.get('name')" />
      </div>

      <div class="w-full">
        <label for="priority">Prioridade *</label>
        <p-inputNumber
          formControlName="priority"
          inputId="priority"
          [useGrouping]="false"
          class="w-full"
        ></p-inputNumber>
        <app-form-error [control]="formGroup.get('priority')" />
        <app-form-server-error [control]="formGroup.get('priority')" />
      </div>
    </div>

    <div class="w-full">
      <label for="description">Descrição</label>
      <input
        pInputText
        type="text"
        formControlName="description"
        class="w-full"
        placeholder="Informe a descrição"
      />
      <app-form-error [control]="formGroup.get('description')" />
      <app-form-server-error [control]="formGroup.get('description')" />
    </div>

    <div class="flex flex-wrap xl:flex-nowrap gap-5">
      <div class="w-full">
        <label for="type">Tipo *</label>
        <p-select
          formControlName="type"
          [options]="assessmentTypeOptions"
          optionLabel="label"
          optionValue="value"
          placeholder="Selecione o tipo"
          class="w-full"
        >
        </p-select>
        <app-form-error [control]="formGroup.get('type')" />
        <app-form-server-error [control]="formGroup.get('type')" />
      </div>

      <div class="w-full">
        <label for="isRequired">Avaliação obrigatória?</label>
        <div class="flex gap-2 items-center mt-2">
          <p-toggleswitch formControlName="isRequired"></p-toggleswitch>
          {{ formGroup.get("isRequired")!.value ? "Sim" : "Não" }}
        </div>
        <app-form-error [control]="formGroup.get('isRequired')" />
        <app-form-server-error [control]="formGroup.get('isRequired')" />
      </div>
    </div>
  </div>

  @if(loading()){
  <div
    class="absolute inset-0 z-30 flex items-center justify-center bg-black/20 backdrop-blur-sm rounded-lg"
  >
    <p-progress-spinner ariaLabel="loading" />
  </div>
  }
</form>

<p-toast />
